export default function createFormData(name, data) {

    const formData = new FormData()
    formData.append("form-name", "Contact")
    Object.entries(data).forEach(([key, value]) => {
        formData.append(key, value)
    })
    console.log(formData)
    return formData
}   